import { createContext } from "react";

export const AuthContext = createContext<any | null>(null);
